// import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./Components/Home/Home";
import About from "./Components/About-Us/About";
import Ourdoctor from "./Components/OurDoctor/Ourdoctor";
import Service from "./Components/Mainservice/Service";
import { createContext, useState } from "react";
import Contactus from "./Components/ContactUs/Contactus";
import Gallery from "./Components/Gallery/Gallery";
import Twodoctors from "./Components/OurDoctor/Twodoctors";
import BoneFracture from "./Components/Mainservice/BoneFracture";
import OrthopaedicClinic from "./Components/Mainservice/OrthopaedicClinic";
import OrthopaedicConsultation from "./Components/Mainservice/OrthopaedicConsultation";
import OrthopaedicEvaluation from "./Components/Mainservice/OrthopaedicEvaluation";
import TreatmentPlanning from "./Components/Mainservice/TreatmentPlanning";
import FractureTraumaCare from "./Components/Mainservice/FractureTraumaCare";
import PlasterCasting from "./Components/Mainservice/PlasterCasting";
import SportMedicine from "./Components/Mainservice/SportMedicine";
import SportsInjury from "./Components/Mainservice/SportsInjury";
import LigamentInjuries from "./Components/Mainservice/LigamentInjuries";
import TendonMuscleInjuries from "./Components/Mainservice/TendonMuscleInjuries";
import ReturnToSport from "./Components/Mainservice/ReturnToSport";
import ArthroscopicAcl from "./Components/Mainservice/ArthroscopicAcl";
import ArthroscopicShoulder from "./Components/Mainservice/ArthroscopicShoulder";
import Arthroscopy from "./Components/Mainservice/Arthroscopy";
import ArthritisJointPain from "./Components/Mainservice/ArthritisJointPain";
import JointReplacement from "./Components/Mainservice/JointReplacement";
import BackPain from "./Components/Mainservice/BackPain";
import BackSpineCare from "./Components/Mainservice/BackSpineCare";
import PaediatricOrthopaedics from "./Components/Mainservice/PaediatricOrthopaedics";
import CongenitalOrtho from "./Components/Mainservice/CongenitalOrtho";
import PainManagement from "./Components/Mainservice/PainManagement";
import JointInjections from "./Components/Mainservice/JointInjections";
import PrpTherapy from "./Components/Mainservice/PrpTherapy";
import Rehabilitation from "./Components/Mainservice/Rehabilitation";
import PostOpRehab from "./Components/Mainservice/PostOpRehab";
import MobilityExercises from "./Components/Mainservice/MobilityExercises";
import KneeAndHip from "./Components/Mainservice/KneeAndHip";
import DiabeticWound from "./Components/Mainservice/DiabeticWound";
import GeneralObstetrics from "./Components/Mainservice/GeneralObstetrics";
import HighRiskObstetric from "./Components/Mainservice/HighRiskObstetric";
import PIH from "./Components/Mainservice/PIH";
import APH from "./Components/Mainservice/APH";
import PPH from "./Components/Mainservice/PPH";
import EctopicPregnancy from "./Components/Mainservice/EctopicPregnancy";
import PreEclampsia from "./Components/Mainservice/PreEclampsia";
import InevitableAbortion from "./Components/Mainservice/InevitableAbortion";
import Respiratory from "./Components/Mainservice/Respiratory";
import OrthopedicProblem from "./Components/Mainservice/OrthopedicProblem";
import InfectionsDisease from "./Components/Mainservice/InfectionsDisease";
import Hysterectomy from "./Components/Mainservice/Hysterectomy";
import Laboratory from "./Components/Mainservice/Laboratory";
import Wounddressing from "./Components/Mainservice/Wounddressing";
import Highintensity from "./Components/Mainservice/Highintensity";

const data = createContext();
const data1 = createContext();
function App() {
  const [serviceset, setServiceset] = useState(
    "Bone Fracture Treatment Surgical And Conservative Treatment"
  );
  return (
    <data.Provider value={serviceset}>
      <data1.Provider value={setServiceset}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />}></Route>
            <Route path="/about" element={<About />}></Route>
            <Route path="/drchethankumarr" element={<Ourdoctor />}></Route>
            <Route path="/drkrupankabv" element={<Twodoctors />}></Route>
            <Route path="/service" element={<Service />}>
              <Route
                path="/service/orthopaedicClinic"
                element={<OrthopaedicClinic />}
              ></Route>
              <Route
                path="/service/orthopaedicConsultation"
                element={<OrthopaedicConsultation />}
              ></Route>
              <Route
                path="/service/orthopaedicEvaluation"
                element={<OrthopaedicEvaluation />}
              ></Route>
              <Route
                path="/service/treatmentPlanning"
                element={<TreatmentPlanning />}
              ></Route>
              <Route
                path="/service/boneFracture"
                element={<BoneFracture />}
              ></Route>
              <Route
                path="/service/fractureTraumaCare"
                element={<FractureTraumaCare />}
              ></Route>
              <Route
                path="/service/plasterCasting"
                element={<PlasterCasting />}
              ></Route>
              <Route
                path="/service/sportMedicine"
                element={<SportMedicine />}
              ></Route>
              <Route
                path="/service/sportsInjury"
                element={<SportsInjury />}
              ></Route>
              <Route
                path="/service/ligamentInjuries"
                element={<LigamentInjuries />}
              ></Route>
              <Route
                path="/service/tendonMuscleInjuries"
                element={<TendonMuscleInjuries />}
              ></Route>
              <Route
                path="/service/returnToSport"
                element={<ReturnToSport />}
              ></Route>
              <Route
                path="/service/arthroscopicAcl"
                element={<ArthroscopicAcl />}
              ></Route>
              <Route
                path="/service/arthroscopicShoulder"
                element={<ArthroscopicShoulder />}
              ></Route>
              <Route
                path="/service/arthroscopy"
                element={<Arthroscopy />}
              ></Route>
              <Route
                path="/service/arthritisJointPain"
                element={<ArthritisJointPain />}
              ></Route>
              <Route
                path="/service/jointReplacement"
                element={<JointReplacement />}
              ></Route>
              <Route path="/service/backPain" element={<BackPain />}></Route>
              <Route
                path="/service/backSpineCare"
                element={<BackSpineCare />}
              ></Route>
              <Route
                path="/service/paediatricOrthopaedics"
                element={<PaediatricOrthopaedics />}
              ></Route>
              <Route
                path="/service/congenitalOrtho"
                element={<CongenitalOrtho />}
              ></Route>
              <Route
                path="/service/painManagement"
                element={<PainManagement />}
              ></Route>
              <Route
                path="/service/jointInjections"
                element={<JointInjections />}
              ></Route>
              <Route
                path="/service/prpTherapy"
                element={<PrpTherapy />}
              ></Route>
              <Route
                path="/service/rehabilitation"
                element={<Rehabilitation />}
              ></Route>
              <Route
                path="/service/postOpRehab"
                element={<PostOpRehab />}
              ></Route>
              <Route
                path="/service/mobilityExercises"
                element={<MobilityExercises />}
              ></Route>
              <Route
                path="/service/kneeAndHip"
                element={<KneeAndHip />}
              ></Route>
              <Route
                path="/service/diabeticWound"
                element={<DiabeticWound />}
              ></Route>
              <Route
                path="/service/generalObstetrics"
                element={<GeneralObstetrics />}
              ></Route>
              <Route
                path="/service/highRiskObstetric"
                element={<HighRiskObstetric />}
              ></Route>
              <Route path="/service/pih" element={<PIH />}></Route>
              <Route path="/service/aph" element={<APH />}></Route>
              <Route path="/service/pph" element={<PPH />}></Route>
              <Route
                path="/service/ectopicPregnancy"
                element={<EctopicPregnancy />}
              ></Route>
              <Route
                path="/service/preEclampsia"
                element={<PreEclampsia />}
              ></Route>
              <Route
                path="/service/inevitableAbortion"
                element={<InevitableAbortion />}
              ></Route>
              <Route
                path="/service/respiratory"
                element={<Respiratory />}
              ></Route>
              <Route
                path="/service/orthopedicProblem"
                element={<OrthopedicProblem />}
              ></Route>
              <Route
                path="/service/infectionsDisease"
                element={<InfectionsDisease />}
              ></Route>
              <Route
                path="/service/hysterectomy"
                element={<Hysterectomy />}
              ></Route>
              <Route
                path="/service/highintensity"
                element={<Highintensity />}
              ></Route>
              <Route
                path="/service/laboratory"
                element={<Laboratory />}
              ></Route>
              <Route
                path="/service/wounddressing"
                element={<Wounddressing />}
              ></Route>
            </Route>
            <Route path="/contact" element={<Contactus />}></Route>
            <Route path="/gallery" element={<Gallery />}></Route>
          </Routes>
        </BrowserRouter>
      </data1.Provider>
    </data.Provider>
  );
}

export default App;
export { data, data1 };
